/**
 * This constant stores conjugations and singular/plural forms of various entities and roles
 * used throughout the app. 
 */
export const words = {
  entities: {
    guilds: {
      entity: 'guild',
      entities: 'guilds',
      an_entity: 'a guild',
      Entity: 'Guild',
      An_Entity: 'A Guild',
      Entities: 'Guilds',
    },
    projects: {
      entity: 'project',
      entities: 'projects',
      an_entity: 'a project',
      Entity: 'Project',
      An_Entity: 'A Project',
      Entities: 'Projects',
    },
    members: {
      entity: 'member',
      entities: 'members',
      an_entity: 'a member',
      Entity: 'Member',
      An_Entity: 'A Member',
      Entities: 'Members',
    },
    guildMembers: {
      entity: 'guild member',
      entities: 'guild members',
      an_entity: 'a guild member',
      Entity: 'Guild Member',
      An_Entity: 'A Guild Member',
      Entities: 'Guild Members',
    },
    projectMembers: {
      entity: 'project member',
      entities: 'project members',
      an_entity: 'a project member',
      Entity: 'Project Member',
      An_Entity: 'A Project Member',
      Entities: 'Project Members',
    },
  },
  
  /**
   * Refers to the person in a particular role.
   */
  membersInRoles: {
    
    /*=== GUILD/PROJECT ROLES ===*/

    supporter: {
      member: 'supporter',
      members: 'supporters',
      a_member: 'a supporter',
      Member: 'Supporter',
      A_Member: 'A Supporter',
      Members: 'Supporters',
    },
    contributor: {
      member: 'contributor',
      members: 'contributors',
      a_member: 'a contributor',
      Member: 'Contributor',
      A_Member: 'A Contributor',
      Members: 'Contributors',
    },
    organizer: {
      member: 'organizer',
      members: 'organizers',
      a_member: 'an organizer',
      Member: 'Organizer',
      A_Member: 'An Organizer',
      Members: 'Organizers',
    },
    point: {
      member: 'point',
      members: 'points',
      a_member: 'a point',
      Member: 'Point',
      A_Member: 'A Point',
      Members: 'Points',
    },

    /*=== QUORUM MEMBER LEVELS ===*/

    network: {
      member: 'network member',
      members: 'network members',
      a_member: 'a network member',
      Member: 'Network Member',
      A_Member: 'A Network Member',
      Members: 'Network Members',
    },
    // contributor is the same
    foundation: {
      member: 'foundation member',
      members: 'foundation members',
      a_member: 'a foundation member',
      Member: 'Foundation Member',
      A_Member: 'A Foundation Member',
      Members: 'Foundation Members',
    },
    steward: {
      member: 'steward',
      members: 'stewards',
      a_member: 'a steward',
      Member: 'Steward',
      A_Member: 'A Steward',
      Members: 'Stewards',
    },

  },

  actionNouns: {
    request: {
      action: 'request',
      actions: 'requests',
      an_action: 'a request',
      Action: 'Request',
      An_Action: 'A Request',
      Actions: 'Requests',
    },
    invitation: {
      action: 'invitation',
      actions: 'invitations',
      an_action: 'an invitation',
      Action: 'Invitation',
      An_Action: 'An Invitation',
      Actions: 'Invitations',
    },
  },

};

/**
 * subject, subjects, a_subject, Subject, A_Subject, Subjects
 */
export const subjectWords = (subjectEntity) => ({
  subject: words.entities[subjectEntity].entity,
  subjects: words.entities[subjectEntity].entities,
  a_subject: words.entities[subjectEntity].an_entity,
  Subject: words.entities[subjectEntity].Entity,
  A_Subject: words.entities[subjectEntity].An_Entity,
  Subjects: words.entities[subjectEntity].Entities,
});

/**
 * parent, parents, a_parent, Subject, A_Subject, Subjects
 */
export const parentWords = (parentEntity) => ({
  parent: words.entities[parentEntity].entity,
  parents: words.entities[parentEntity].entities,
  a_parent: words.entities[parentEntity].an_entity,
  Parent: words.entities[parentEntity].Entity,
  A_Parent: words.entities[parentEntity].An_Entity,
  Parents: words.entities[parentEntity].Entities,
});

/**
 * member, members, a_member, Member,A_Member, Members
 */
export const membersInRoleWords = (roleName) => ({
  ...words.membersInRoles[roleName],
});

/**
 * action, actions, an_action, Action, An_Action, Actions
 */
export const actionNounWords = (actionName) => ({
  ...words.actionNouns[actionName],
});
